import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {AppReduxState} from "core/redux/app/AppReduxState";
import {
    CloseMeType,
    SetBarBottomMetrics,
    SetBarBottomMetricsPayload,
    SetComplianceFlow,
    SetComplianceFlowPayload,
    SetModal,
    SetModalPayload
} from "core/redux/app/AppReduxActions";
import AppEngine from "core/engine/AppEngine";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {LoadLanguageType} from "platform/redux/translation/TranslationActions";
import {TSMap} from "typescript-map";
import Utils from "platform/util/Utils";
import {SetAppReadyType} from "platform/redux/core/CoreActions";

export default class AppReducer extends Reducer<AppReduxState> {

    private static _instance: AppReducer;

    public static instance(): AppReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const appEngine: AppEngine = Platform.engine(ServiceType.App);
        this._middlewareActions.set(SetAppReadyType, appEngine.onAppReady);
        this._middlewareActions.set(LoadLanguageType, appEngine.onLoadLanguage);
        this._middlewareActions.set(CloseMeType, appEngine.closeMe);
    }

    public get name(): string {
        return "app";
    }

    protected setup(builder: ReducerBuilder<AppReduxState>): void {
        builder
            .init({
                modals: new TSMap(),
                barBottomHeight: 0
            })
            .handle(SetComplianceFlow, (state: AppReduxState, {payload}: Action<SetComplianceFlowPayload>) => {
                return Object.assign({}, state, {
                    complianceFlowType: payload.complianceFlowType
                });
            })
            .handle(SetModal, (state: AppReduxState, {payload}: Action<SetModalPayload>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.modals.set(payload.modalType, payload.visible);
                return newState;
            })
            .handle(SetBarBottomMetrics, (state: AppReduxState, {payload}: Action<SetBarBottomMetricsPayload>) => {
                this._logger.debug("Set bar bottom height: " + payload.height);
                return Object.assign({}, state, {
                    barBottomHeight: Utils.isNotNull(payload.height) ? payload.height : state.barBottomHeight
                });
            });
    }
}
